export default class search {
  constructor() {
    this.state = {};
  }

  init() {
    console.log(`Hello from ${this.constructor.name}!`);
  }
}
